document.addEventListener('DOMContentLoaded', function () {
  const canvasElement = document.getElementById('designer-canvas');
  const wrapper = document.querySelector('.canvas-container-wrapper');

  if (!canvasElement || !wrapper) return;

  canvasElement.width = wrapper.offsetWidth;
  canvasElement.height = wrapper.offsetHeight;

  const canvas = new fabric.Canvas('designer-canvas', {
    backgroundColor: '#f9f9f9'
  });

  // Resize canvas to match wrapper
  function resizeCanvas() {
    canvas.setWidth(wrapper.offsetWidth);
    canvas.setHeight(wrapper.offsetHeight);
    canvas.renderAll();
  }

  window.addEventListener('resize', resizeCanvas);

  // ─────────────────────────────────────────
  // Load the base product image as a Fabric background image.
  // This avoids all CORS canvas-tainting issues because Fabric
  // manages the image internally and toDataURL() works cleanly.
  // ─────────────────────────────────────────
  const baseImage = document.getElementById('product-base-image');

  function loadBackgroundImage() {
    if (!baseImage || !baseImage.src) return;

    fabric.Image.fromURL(baseImage.src, function (img) {
      if (!img || img.width === 0) {
        // CORS failed — keep the DOM image visible as visual fallback
        console.warn('Background image CORS load failed. Keeping DOM image.');
        return;
      }

      // Scale to fill canvas using object-fit: contain logic
      const hRatio = canvas.getWidth() / img.width;
      const vRatio = canvas.getHeight() / img.height;
      const ratio = Math.min(hRatio, vRatio);

      img.set({
        scaleX: ratio,
        scaleY: ratio,
        originX: 'center',
        originY: 'center',
        left: canvas.getWidth() / 2,
        top: canvas.getHeight() / 2
      });

      canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));

      // Hide the DOM image — canvas now shows the product
      baseImage.style.display = 'none';

    }, { crossOrigin: 'anonymous' });
  }

  if (baseImage) {
    if (baseImage.complete && baseImage.naturalWidth > 0) {
      resizeCanvas();
      loadBackgroundImage();
    } else {
      baseImage.addEventListener('load', function () {
        resizeCanvas();
        loadBackgroundImage();
      });
    }
  }

  // ─────────────────────────────────────────
  // Design tools
  // ─────────────────────────────────────────
  const addTextBtn = document.getElementById('add-text-btn');
  const imageUpload = document.getElementById('image-upload');
  const deleteBtn = document.getElementById('delete-btn');
  const colorPicker = document.getElementById('color-picker');
  const editTools = document.getElementById('edit-tools');

  // Add text
  addTextBtn.addEventListener('click', function () {
    var text = new fabric.IText('Your Text Here', {
      left: canvas.width / 2,
      top: canvas.height / 2,
      fontFamily: 'Helvetica',
      fill: '#000000',
      originX: 'center',
      originY: 'center',
      fontSize: 30
    });
    canvas.add(text);
    canvas.setActiveObject(text);
  });

  // Upload user image onto canvas
  imageUpload.addEventListener('change', function (e) {
    var file = e.target.files[0];
    if (!file) return;

    var reader = new FileReader();
    reader.onload = function (f) {
      var data = f.target.result;
      fabric.Image.fromURL(data, function (img) {
        if (img.width > canvas.width * 0.8 || img.height > canvas.height * 0.8) {
          img.scaleToWidth(canvas.width * 0.8);
        }
        img.set({
          left: canvas.width / 2,
          top: canvas.height / 2,
          originX: 'center',
          originY: 'center',
          originalFile: file // Store the original file for uploading to Shopify
        });
        // Also store it in a custom property so Fabric doesn't strip it
        img.originalFile = file;

        canvas.add(img);
        canvas.setActiveObject(img);
      });
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  });

  // Selection events
  canvas.on('selection:created', showEditTools);
  canvas.on('selection:updated', showEditTools);
  canvas.on('selection:cleared', hideEditTools);

  function showEditTools(e) {
    editTools.style.display = 'block';
    var activeObj = e.selected[0];
    if (activeObj && activeObj.fill && typeof activeObj.fill === 'string') {
      colorPicker.value = activeObj.fill;
    }
  }
  function hideEditTools() {
    editTools.style.display = 'none';
  }

  // Delete element
  deleteBtn.addEventListener('click', function (e) {
    e.preventDefault();
    var activeObject = canvas.getActiveObject();
    if (activeObject) {
      canvas.remove(activeObject);
      canvas.discardActiveObject();
    }
  });

  // Colour picker
  colorPicker.addEventListener('input', function (e) {
    var activeObject = canvas.getActiveObject();
    if (activeObject) {
      if (activeObject.type === 'i-text' || activeObject.type === 'text') {
        activeObject.set('fill', e.target.value);
        canvas.renderAll();
      }
    }
  });

  // ─────────────────────────────────────────
  // Add to Cart
  // ─────────────────────────────────────────
  var addToCartForm = document.getElementById('add-to-cart-form');

  if (addToCartForm) {
    var isSubmitting = false;

    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isSubmitting) return;
      isSubmitting = true;

      var submitBtn = document.getElementById('add-to-cart-btn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = 'Adding...';
      }

      // Deselect to remove blue selection borders from final image
      canvas.discardActiveObject();
      canvas.renderAll();

      // Export canvas at up to 600px wide (background image already included)
      var maxWidth = 600;
      var exportWidth = Math.min(wrapper.offsetWidth, maxWidth);
      var exportMult = exportWidth / canvas.getWidth();

      var dataUrl = canvas.toDataURL({
        format: 'jpeg',
        quality: 0.85,
        multiplier: exportMult
      });

      // Save to localStorage and pass only a short ID to Shopify cart
      var designId = 'design_' + Date.now().toString(36) + Math.random().toString(36).substr(2);
      try {
        localStorage.setItem(designId, dataUrl);
      } catch (err) {
        console.warn('localStorage unavailable:', err);
      }

      var formData = new FormData(addToCartForm);
      formData.delete('properties[Custom Design]');
      formData.append('properties[_custom_design_id]', designId);
      formData.append('properties[Design Status]', 'Customized Product');

      // Helper to convert dataURL to File for Shopify properties
      function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }

      // 1. Capture the FINAL DESIGN LAYOUT (screenshot of the shirt + designs)
      var layoutFile = dataURLtoFile(dataUrl, 'design-layout-preview.jpg');
      formData.append('properties[Final Design Layout Preview]', layoutFile);

      // 2. Add individual High-Quality images and Text content
      let imageIndex = 1;
      let textIndex = 1;
      const allObjects = canvas.getObjects();

      allObjects.forEach(function (obj) {
        // Handle images
        const file = obj.originalFile || (obj.get && obj.get('originalFile'));
        if (file) {
          formData.append(`properties[Original Image ${imageIndex}]`, file);
          imageIndex++;
        }

        // Handle text
        if (obj.type === 'i-text' || obj.type === 'text') {
          formData.append(`properties[Custom Text ${textIndex}]`, obj.text);
          textIndex++;
        }
      });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed: ' + response.status);
          return response.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('Error adding to cart:', err);
          alert('Sorry, there was an issue adding to the cart. Please try again.');
          isSubmitting = false;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerText = 'Add to Cart';
          }
        });
    });
  }
});
